module.exports = __webpack_public_path__ + "static/media/img-registre.f3db6c8b.png";